import React, { useEffect, useState } from 'react';
import './HomePage.css';
import VideoThumbnail from '../../Components/VideoThumbnail/VideoThumbnail';
import VideoGrid from '../../Components/VideoGrid/VideoGrid';
import { Box } from '@mui/system';
import { Container } from '@mui/material';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { VideoList } from '../../Assets/Videos/VideoList.js';

const dummyData = [
    { name: "test video 1" },
    { name: "test video 2" },
    { name: "test video 3" },
    { name: "test video 4" },
];

const HomePage = (props) => {
    const [videos, setVideos] = useState([]);

    useEffect(() => {
        // get_text_file(`VideoList.txt`).then(r => {
        //     //console.log(r);
        //     var result = JSON.parse(r);
        //     setVideos(result);
        // }).catch(console.error);
        //setVideos(dummyData);
        console.log(VideoList);
        setVideos(VideoList);
    }, []);

    const get_text_file = async (filepath) => {
        // prefix public dir files with `process.env.PUBLIC_URL`
        // see https://create-react-app.dev/docs/using-the-public-folder/
        const res = await fetch(`${process.env.PUBLIC_URL}/${filepath}`);
      
        // check for errors
        if (!res.ok) {
          throw res;
        }
      
        return res.text();
    };

    // useEffect(() => {
    //     (async () => {
    //         const res = await fetch(`${process.env.PUBLIC_URL}/VideoList.txt`);
    //         console.log(res.text());
    //         setVideos(dummyData);
    //     })();
      
    //     return () => {
    //     };
    //   }, []);

    return (
            <div className='center'>
                <Container>
                    <VideoGrid videos={videos} />
                </Container>
            </div>
    );
};

export default HomePage;